<template>
    <div class="form_box">

        <div class="top_part">
            <div class="info_row file">
                <span class="input_description">Логотип</span>

                <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
                <label for="file_avatar" :style="{backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + restaurant.logo + ')'}"></label>
            </div>

            <div class="info_row">
                <span class="input_description">Город</span>
                <select class="select_city select_info full" v-model="restaurant.city_id">
                    <option v-if="restaurant.city_id" :value="(restaurant.city_id).toString()">{{restaurant.city_name}}</option>
                </select>
            </div>

            <div class="info_row" v-if="user.access === 'admin'">
                <span class="input_description">Процент приыбли</span>
                <input class="max" type="number" placeholder="10%" v-model="restaurant.payout_percent" min="0" max="100" >
            </div>
            <div class="info_row" v-if="user.access === 'admin'">
                <span class="input_description">АльфаБанк логин</span>
                <input class="max" type="text" v-model="restaurant.alfa_login">
            </div>

            <div class="info_row">
                <span class="input_description">Пользователь</span>
                <select class="select_user select_info full" v-model="restaurant.user_id">
                    <option v-if="restaurant.user_id" :value="(restaurant.user_id).toString()">{{restaurant.user_name}}</option>
                </select>
            </div>

            <div class="info_row">
                <span class="input_description">Название</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.name">
            </div>

            <div class="info_row">
                <span class="input_description">Ресторан работает</span>
                <input type="checkbox" id="post" v-model="restaurant.is_working">
                <label class="checkbox_label" for="post"></label>
            </div>

            <div class="info_row">
                <span class="input_description">Краткое описание</span>
                <textarea class="textarea" placeholder="Введите текст" v-model="restaurant.short_desc"></textarea>
            </div>

            <div class="info_row">
                <span class="input_description">Полное описание</span>
                <textarea class="textarea full" placeholder="Введите текст" v-model="restaurant.desc"></textarea>
            </div>
        </div>

        <div class="middle_part">
            <div class="info_row">
                <span class="input_description">Способы уведомлений</span>
                <div class="checkbox_wrap">
                    <input type="checkbox" id="email" v-model="restaurant.alarm_email">
                    <label class="checkbox_label" for="email"></label>
                    <span>E-mail</span>
                </div>
                <div class="checkbox_wrap">
                    <input type="checkbox" id="sms" v-model="restaurant.alarm_sms">
                    <label class="checkbox_label" for="sms"></label>
                    <span>SMS</span>
                </div>
            </div>

            <div class="info_row">
                <span class="input_description">Тип работы</span>
                <select class="select_worktype select_info" v-model="restaurant.work_type">
                    <option value="1">Ежедневно</option>
                    <option value="2">По дням недели</option>
                </select>
            </div>

            <div class="info_row" v-if="parseInt(restaurant.work_type) === 1">
                <span class="input_description">Время приема заказов</span>
                <select class="select_info time select_workfrom" v-model="restaurant.work_from">
                    <option :value="index" v-for="(hour, index) in hours" :key="index">{{hour}}</option>
                </select>

                <select class="select_info time select_workto" v-model="restaurant.work_to">
                    <option :value="index" v-for="(hour, index) in hours" :key="index">{{hour}}</option>
                </select>
            </div>
            <div class="info_row" v-else-if="parseInt(restaurant.work_type) === 2">
                <div v-for="(day, indexDay) in days" :key="indexDay">
                    <span class="input_description">{{day}}</span>
                    <select class="select_info time select_workfrom" v-model="restaurant.works[indexDay].from">
                        <option :value="index" v-for="(hour, index) in hours" :key="index">{{hour}}</option>
                    </select>

                    <select class="select_info time select_workto" v-model="restaurant.works[indexDay].to">
                        <option :value="index" v-for="(hour, index) in hours" :key="index">{{hour}}</option>
                    </select>
                </div>
            </div>
            <div class="info_row">
                <span class="input_description">Способы оплаты</span>
                <select class="select_info full select_payments" multiple v-model="restaurant.payments">
                    <option :value="index" v-for="(payment, index) in restaurant.payments_all" :key="index">{{payment}}</option>
                </select>
            </div>

            <div class="info_row">
                <span class="input_description">Кухня</span>
                <select class="select_info full select_kitchens" multiple v-model="restaurant.kitchens">
                    <option :value="index" v-for="(kitchen, index) in restaurant.kitchens_all" :key="index">{{kitchen}}</option>
                </select>
            </div>

            <div class="info_row">
                <span class="input_description">Минимальный заказ, руб</span>
                <input class="max" type="number" v-model="restaurant.minimal_amount" min="0">
            </div>

            <div class="info_row">
                <span class="input_description">Стоимость доставки, руб</span>
                <input class="max" type="number" v-model="restaurant.delivery_price" min="0">
            </div>

            <div class="info_row">
                <span class="input_description">Бесплатная доставка от, руб</span>
                <input class="max" type="number" v-model="restaurant.free_from" min="0">
            </div>

            <div class="info_row">
                <span class="input_description">Время доставки, мин</span>
                <input class="max" type="number" v-model="restaurant.delivery_time" min="0">
            </div>

            <div class="info_row">
                <span class="input_description">Стоимость доставки за 1 км, руб</span>
                <input class="max" type="number" v-model="restaurant.delivery_km" min="0">
            </div>

            <div class="info_row">
                <div class="description_box">
                    <span>Скидка при самовывозе</span>
                    <p class="input_notice"><strong>*</strong> - если скидка не предусмотрена - укажите 0</p>
                </div>
                <div class="extra_info">
                    <select class="select_info extra_myself_discount_name" v-model="restaurant.myself_discount_name">
                        <option value="Проценты">Проценты</option>
                        <option value="Фиксированное число">Фиксированное число</option>
                    </select>
                    <input type="number" v-model="restaurant.myself_discount_value" class="extra">
                </div>
            </div>

            <div class="info_row">
                <div class="description_box">
                    <span>Сумма для оплаты бонусами</span>
                    <p class="input_notice"><strong>*</strong> - если скидка не предусмотрена - укажите 0</p>
                </div>
                <div class="extra_info">
                    <select class="select_info extra_bonus_payment_name" v-model="restaurant.bonus_payment_name">
                        <option value="Проценты">Проценты</option>
                        <option value="Фиксированное число">Фиксированное число</option>
                    </select>
                    <input type="number" v-model="restaurant.bonus_payment_value" class="extra">
                </div>
            </div>

            <div class="info_row">
                <div class="description_box">
                    <span>Сумма скидки в день рождения</span>
                    <p class="input_notice"><strong>*</strong> - если скидка не предусмотрена - укажите 0</p>
                </div>
                <div class="extra_info">
                    <select class="select_info extra_birthday_discount_name" v-model="restaurant.birthday_discount_name">
                        <option value="Проценты">Проценты</option>
                        <option value="Фиксированное число">Фиксированное число</option>
                    </select>
                    <input type="number" v-model="restaurant.birthday_discount_value" class="extra">
                </div>
            </div>
        </div>

        <div class="bottom_part">

            <div class="info_row">
                <span class="input_description">Тел. номер</span>
                <input class="max" type="text" placeholder="+7(__)__-__-__" v-model="restaurant.phone" data-inputmask="'mask': '+9(999)999-99-99'">
            </div>

            <div class="info_row">
                <span class="input_description">WhatsApp</span>
                <input class="max" type="text" placeholder="+7(__)__-__-__" v-model="restaurant.whatsapp" data-inputmask="'mask': '+9(999)999-99-99'">
            </div>

            <div class="info_row">
                <span class="input_description">Telegram</span>
                <input class="max" type="text" placeholder="+7(__)__-__-__" v-model="restaurant.telegram" data-inputmask="'mask': '+9(999)999-99-99'">
            </div>

            <div class="info_row">
                <span class="input_description">Viber</span>
                <input class="max" type="text" placeholder="+7(__)__-__-__" v-model="restaurant.viber" data-inputmask="'mask': '+9(999)999-99-99'">
            </div>

            <div class="info_row">
                <span class="input_description">E-mail</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.email" >
            </div>

            <div class="info_row">
                <span class="input_description">Название организации (ООО/ИП)</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.full_legal_name">
            </div>
            <div class="info_row">
                <span class="input_description">Адресс организации</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.legal_address">
            </div>

            <div class="info_row">
                <span class="input_description">Банк</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.bank_name">
            </div>

            <div class="info_row">
                <span class="input_description">ИНН</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.inn">
            </div>

            <div class="info_row">
                <span class="input_description">КПП</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.kpp">
            </div>

            <div class="info_row">
                <span class="input_description">ОГРН/ОГРНИП </span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.ogrn">
            </div>

            <div class="info_row">
                <span class="input_description">БИК</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.bik">
            </div>

            <div class="info_row">
                <span class="input_description">Расчетный счёт</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.checking_account">
            </div>

            <div class="info_row">
                <span class="input_description">Корреспондентский счёт</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.correspondent_account">
            </div>

            <div class="info_row">
                <span class="input_description">E-mail бухгалтерии</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.fin_email">
            </div>

            <div class="info_row">
                <span class="input_description">Договор подписан</span>
                <input type="checkbox" id="contract" v-model="restaurant.contract_check">
                <label class="checkbox_label" for="contract"></label>
            </div>

            <div class="info_row">
                <span class="input_description">Номер договора</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="restaurant.dogovor">
            </div>

            <div class="info_row">
                <span class="input_description">Дата заключения</span>
                <input class="max" type="date" placeholder="__/__/__" v-model="restaurant.date">
            </div>

            <div class="info_row">
                <span class="input_description">Адрес</span>
                <input type="text" placeholder="Введите текст" class="max" v-model="restaurant.address" ref="autocomplete">
            </div>

            <div id="main_map" ref="map" style="height: 300px"></div>
        </div>
        <button class="menu_item_btn" @click="saveData">Сохранить</button>

    </div>
</template>

<script>
import Inputmask from 'inputmask'
import axios from '@/router/http'
import 'select2/dist/css/select2.min.css'
import 'select2'
export default {
  name: 'index',
  props: ['auth', 'id', 'mapinit', 'user'],
  data () {
    return {
      map: null,
      initAutocompleteInterval: null,
      autocomplete: null,
      bounds: null,
      marker: null,
      restaurant: {
        kitchens: [],
        payments: []
      },
      hours: {
        '00:00:00': '00:00',
        '00:30:00': '00:30',
        '01:00:00': '01:00',
        '01:30:00': '01:30',
        '02:00:00': '02:00',
        '02:30:00': '02:30',
        '03:00:00': '03:00',
        '03:30:00': '03:30',
        '04:00:00': '04:00',
        '04:30:00': '04:30',
        '05:00:00': '05:00',
        '05:30:00': '05:30',
        '06:00:00': '06:00',
        '06:30:00': '06:30',
        '07:00:00': '07:00',
        '07:30:00': '07:30',
        '08:00:00': '08:00',
        '08:30:00': '08:30',
        '09:00:00': '09:00',
        '09:30:00': '09:30',
        '10:00:00': '10:00',
        '10:30:00': '10:30',
        '11:00:00': '11:00',
        '11:30:00': '11:30',
        '12:00:00': '12:00',
        '12:30:00': '12:30',
        '13:00:00': '13:00',
        '13:30:00': '13:30',
        '14:00:00': '14:00',
        '14:30:00': '14:30',
        '15:00:00': '15:00',
        '15:30:00': '15:30',
        '16:00:00': '16:00',
        '16:30:00': '16:30',
        '17:00:00': '17:00',
        '17:30:00': '17:30',
        '18:00:00': '18:00',
        '18:30:00': '18:30',
        '19:00:00': '19:00',
        '19:30:00': '19:30',
        '20:00:00': '20:00',
        '20:30:00': '20:30',
        '21:00:00': '21:00',
        '21:30:00': '21:30',
        '22:00:00': '22:00',
        '22:30:00': '22:30',
        '23:00:00': '23:00',
        '23:30:00': '23:30',
        '24:00:00': '24:00'
      },
      days: {
        'Monday': 'Понедельник',
        'Tuesday': 'Вторник',
        'Wednesday': 'Среда',
        'Thursday': 'Четверг',
        'Friday': 'Пятница',
        'Saturday': 'Суббота',
        'Sunday': 'Воскресенье'
      },
      citys: null,
      users: null,
      file: null
    }
  },
  created () {
    if (this.auth.uid) this.loadRest()
    else {
      setTimeout(() => {
        if (this.auth.uid) this.loadRest()
      }, 100)
    }
  },
  methods: {
    handleFileUpload () {
      var reader = new FileReader()
      reader.onload = (e) => {
        $('label[for="file_avatar"]').css('background-image', `url(${e.target.result})`)
        this.file = e.target.result
      }
      reader.readAsDataURL(this.$refs.file.files[0])
    },
    saveData () {
      console.log(JSON.parse(JSON.stringify(this.restaurant)))
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('restaurant', JSON.stringify(this.restaurant))
      if (this.file !== null) formData.append('photo', this.file)
      axios.post('https://lk.when-hungry.com/mobile/save-restaurant',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    },
    setMap () {
      this.map = new google.maps.Map(this.$refs.map, {
        center: new google.maps.LatLng(this.restaurant.longitude, this.restaurant.latitude),
        zoom: 10,
        disableDefaultUI: true
      })
      this.marker = new google.maps.Marker({
        title: this.restaurant.name,
        position: new google.maps.LatLng(this.restaurant.longitude, this.restaurant.latitude),
        map: this.map,
        draggable: true
      })
      this.map.data.loadGeoJson('https://lk.when-hungry.com/api/get-zones-new?id=' + this.id)

      this.map.data.setStyle(function (feature) {
        return ({
          fillColor: feature.getProperty('fillColor'),
          strokeColor: feature.getProperty('strokeColor'),
          strokeWeight: 2
        })
      })
      let infowindow = new google.maps.InfoWindow()
      google.maps.event.addListener(this.map, 'click', function () {
        infowindow.close()
      })
      this.map.data.addListener('click', function (event) {
        infowindow.setContent('<h3>Ресторан: ' + event.feature.getProperty('title') + '</h3><div>Стоимость доставки: ' + event.feature.getProperty('price') + ' руб</div>')
        infowindow.setPosition(event.latLng)
        // infowindow.setOptions({pixelOffset: new google.maps.Size(0, -30)})
        infowindow.open(this.map)
      })

      var geocode = new google.maps.Geocoder()
      geocode.geocode({'address': this.restaurant.city_name}, (results, status) => {
        if (status === 'OK') {
          this.bounds = results[0].geometry.bounds
          this.autocomplete = new google.maps.places.Autocomplete(
            (this.$refs.autocomplete),
            {
              types: ['geocode'],
              bounds: this.bounds
            }
          )
          this.autocomplete.addListener('place_changed', () => {
            let place = this.autocomplete.getPlace()
            if (this.marker) this.marker.setPosition(place.geometry.location)
            this.map.setCenter(place.geometry.location)
            this.map.setZoom(17)

            var componentForm = {
              street_number: 'short_name',
              route: 'long_name',
              locality: 'long_name',
              administrative_area_level_1: 'short_name'
            }
            var componentsForms = []
            for (var i = 0; i < place.address_components.length; i++) {
              var addressType = place.address_components[i].types[0]
              if (componentForm[addressType]) {
                componentsForms[addressType] = place.address_components[i][componentForm[addressType]]
              }
            }

            this.restaurant.address = [componentsForms['route'] + ' ' + componentsForms['street_number'], componentsForms['administrative_area_level_1'], componentsForms['locality']].join(', ').replace(', ,', ',').replace(', ,', ',')
            this.restaurant.adr = this.restaurant.address
            this.restaurant.address = this.restaurant.address
            this.restaurant.latitude = place.geometry.location.lng()
            this.restaurant.longitude = place.geometry.location.lat()
          })
        }
      })

      google.maps.event.addListener(this.marker, 'dragend', (event) => {
        geocode.geocode({'location': this.marker.getPosition()}, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              this.map.setCenter(this.marker.getPosition())
              this.map.setZoom(17)

              var componentForm = {
                street_number: 'short_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name'
              }
              var componentsForms = []
              for (var i = 0; i < results[0].address_components.length; i++) {
                var addressType = results[0].address_components[i].types[0]
                if (componentForm[addressType]) {
                  componentsForms[addressType] = results[0].address_components[i][componentForm[addressType]]
                }
              }

              this.restaurant.address = [componentsForms['route'] + ' ' + componentsForms['street_number'], componentsForms['administrative_area_level_1'], componentsForms['locality']].join(', ').replace(', ,', ',').replace(', ,', ',')
              this.restaurant.adr = this.restaurant.address
              this.restaurant.address = this.restaurant.address
              this.restaurant.latitude = results[0].geometry.location.lng()
              this.restaurant.longitude = results[0].geometry.location.lat()
            }
          }
        })
      })
    },
    initMap () {
      this.initAutocompleteInterval = setInterval(() => {
        if (this.$root.mapinit && typeof google !== 'undefined') {
          clearInterval(this.initAutocompleteInterval)
          this.setMap()
        }
      }, 500)
    },
    loadRest () {
      if (this.id !== null) {
        let self = this
        axios.get('https://lk.when-hungry.com/mobile/get-restaurant?uid=' + this.auth.uid + '&id=' + this.id).then(response => {
          this.restaurant = response.data
          this.initMap()
          Inputmask().remove(document.getElementById('input'))
          setTimeout(() => { Inputmask().mask(document.querySelectorAll('input')) }, 500)
          $('.select_worktype').select2({}).on('select2:select', function () { self.restaurant.work_type = $(this).val() })
          $('.select_workfrom').select2({}).on('select2:select', function () { self.restaurant.work_from = $(this).val() })
          $('.select_workto').select2({}).on('select2:select', function () { self.restaurant.work_to = $(this).val() })
          $('.select_payments').select2({}).on('select2:select', function () { self.restaurant.payments = $(this).val() })
          $('.select_kitchens').select2({}).on('select2:select', function () { self.restaurant.kitchens = $(this).val() })
          $('.extra_myself_discount_name').select2({}).on('select2:select', function () { self.restaurant.myself_discount_name = $(this).val() })
          $('.extra_bonus_payment_name').select2({}).on('select2:select', function () { self.restaurant.bonus_payment_name = $(this).val() })
          $('.extra_birthday_discount_name').select2({}).on('select2:select', function () { self.restaurant.birthday_discount_name = $(this).val() })
          if (this.restaurant.work_type) $('.select_worktype').val(this.restaurant.work_type).trigger('change.select2')
          if (this.restaurant.work_from) $('.select_workfrom').val(this.restaurant.work_from.toString()).trigger('change.select2')
          if (this.restaurant.work_to) $('.select_workto').val(this.restaurant.work_to.toString()).trigger('change.select2')
          if (this.restaurant.payments) $('.select_payments').val(this.restaurant.payments).trigger('change.select2')
          if (this.restaurant.kitchens) $('.select_kitchens').val(this.restaurant.kitchens).trigger('change.select2')
          if (this.restaurant.myself_discount_name) $('.extra_myself_discount_name').val(this.restaurant.myself_discount_name).trigger('change.select2')
          if (this.restaurant.bonus_payment_name) $('.extra_bonus_payment_name').val(this.restaurant.bonus_payment_name).trigger('change.select2')
          if (this.restaurant.birthday_discount_name) $('.extra_birthday_discount_name').val(this.restaurant.birthday_discount_name).trigger('change.select2')
          $('.select_city').select2({
            width: '100%',
            ajax: {
              url: 'https://lk.when-hungry.com/site/search-city',
              data: (params) => {
                params.id = this.$root.city.country_id
                params.q = params.term
                params.all = 0
                params.country = 1
                params.comm = 1
                return params
              },
              dataType: 'json',
              processResults: function (data) {
                return {
                  results: $.map(data, function (key, item) {
                    return {
                      text: key,
                      id: item
                    }
                  })
                }
              }
            }
          }).trigger('change.select2').on('select2:select', function () {
            self.restaurant.city_id = $(this).val()
          })
          $('.select_city').val(this.restaurant.city_id.toString())
          $('.select_user').select2({
            width: '100%',
            ajax: {
              url: 'https://lk.when-hungry.com/site/search-user',
              dataType: 'json',
              processResults: function (data) {
                return {
                  results: $.map(data, function (key, item) {
                    return {
                      text: key,
                      id: item
                    }
                  })
                }
              }
            }
          }).trigger('change.select2').on('select2:select', function () {
            self.restaurant.user_id = $(this).val()
          })
          $('.select_user').val(this.restaurant.user_id.toString())
        })
      }
    }
  },
  watch: {
    id (val, oldVal) {
      if (val !== oldVal) {
        this.loadRest()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/restaurant/index.vue